import axios from "axios";
import { api } from "@/api";
import { Role } from "@/interfaces/Models";

const types = {
  SET_USER: "SET_USER",
  LOGOUT: "LOGOUT",
  FETCH_USER_FAILURE: "FETCH_USER_FAILURE",
  SET_TOKEN: "SET_TOKEN",
};

const roles = {
  SUPER_ADMIN: "Super Admin",
  ADMIN: "Admin",
  PARENT: "Parent",
  BABYSITTER: "Babysitter",
};

/**
 * Initial state
 */
export const state = {
  user: null,
  token: window.localStorage.getItem("token"),
};

/**
 * Mutations
 */
export const mutations = {
  [types.SET_USER](state: any, { data }: any) {
    state.user = data;
  },

  [types.LOGOUT](state: any) {
    state.user = null;
    state.token = null;
    window.localStorage.removeItem("token");
  },

  [types.FETCH_USER_FAILURE](state: any) {
    state.user = null;
    window.localStorage.removeItem("token");
  },

  [types.SET_TOKEN](state: any, { token }: any) {
    state.token = token;
    window.localStorage.setItem("token", token);
  },
};

/**
 * Actions
 */
export const actions = {
  saveToken({ commit }: any, payload: any) {
    commit(types.SET_TOKEN, payload);
  },

  async fetchUser({ commit }: any) {
    try {
      const { data } = await axios.get(api.path("v1.me"));
      commit(types.SET_USER, data);
    } catch (e) {
      commit(types.FETCH_USER_FAILURE);
    }
  },

  setUser({ commit }: any, payload: any) {
    commit(types.SET_USER, payload);
  },

  async logout({ commit }: any) {
    await axios.post(api.path("v1.logout"));
    commit(types.LOGOUT);
  },

  destroy({ commit }: any) {
    commit(types.LOGOUT);
  },
};

/**
 * Getters
 */
export const getters = {
  user: (state: any) => state.user,
  check: (state: any) => state.user !== null,
  token: (state: any) => state.token,
  roles: (state: any) => state.user.roles,
  admins: (state: any) =>
    state.user.roles.some(
      (role: Role) => role.name == roles.SUPER_ADMIN || role.name == roles.ADMIN
    ),
  superAdmin: (state: any) =>
    state.user.roles.some((role: Role) => role.name == roles.SUPER_ADMIN),
  admin: (state: any) =>
    state.user.roles.some((role: Role) => role.name == roles.ADMIN),
  parent: (state: any) =>
    state.user.roles.some((role: Role) => role.name == roles.PARENT),
  babysitter: (state: any) =>
    state.user.roles.some((role: Role) => role.name == roles.BABYSITTER),
};
